import { AxiosResponse, Canceler } from 'axios';
import settings from '../settings';
import { IApiResult, IPaginationResponseDto, IPenname, IStory } from '../types';
import api from './base';

interface IDeletePennameOptionBase {
  option: 'merge' | 'delete';
  targetPennameId?: number;
}

interface IDeletePennameOptionMerge extends IDeletePennameOptionBase {
  option: 'merge';
  targetPennameId: number;
}

interface IDeletePennameOptionDelete extends IDeletePennameOptionBase {
  option: 'delete';
}

type IDeletePennameOption = IDeletePennameOptionMerge | IDeletePennameOptionDelete;

export function fetchPennames(page = 1, limit?: number, searchKey?: string): [Promise<AxiosResponse<IPaginationResponseDto<IPenname>>>, Canceler] {
  const uri = `${settings.getApiURI()}/penname-admin/v2/pennames`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
      searchKey,
    },
  });
}

export function fetchPenname(pennameId: number): [Promise<AxiosResponse<IPenname>>, Canceler] {
  const uri = `${settings.getApiURI()}/penname-admin/v2/pennames/${pennameId}`;

  return api.getWithCancel(uri);
}

export function createPenname(penname: Partial<IPenname>): Promise<AxiosResponse<IApiResult<IPenname>>> {
  const uri = `${settings.getApiURI()}/penname-admin/v2/pennames`;

  return api.http.post(uri, { ...penname, assigneeIds: penname.licensees ? penname.licensees.map(({ id }) => id) : undefined });
}

export function updatePenname(pennameId: number, penname: Partial<IPenname>): Promise<AxiosResponse<IApiResult<IPenname>>> {
  const uri = `${settings.getApiURI()}/penname-admin/v2/pennames/${pennameId}`;

  return api.http.patch(uri, { ...penname, assigneeIds: penname.licensees ? penname.licensees.map(({ id }) => id) : undefined });
}

export function fetchPennameStories(pennameId: number, page = 1, limit = 20): [Promise<AxiosResponse<IPaginationResponseDto<IStory>>>, Canceler] {
  const uri = `${settings.getApiURI()}/penname-admin/v2/pennames/${pennameId}/stories`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
    },
  });
}

export function deletePenname(pennameId: number, option: IDeletePennameOption): Promise<AxiosResponse<IApiResult<IPenname>>> {
  const uri = `${settings.getApiURI()}/penname-admin/v2/pennames/${pennameId}`;

  return api.http.delete(uri, { data: { data: option } });
}
